import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TokenStorageService} from './_services/token-storage.service';
import {fromEvent, Observable, Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {FormBuilder, FormGroup} from '@angular/forms';
import {PurchaseService} from './_services/purchase.service';
import {Purchase} from './models/eventRequest';
import {DateService} from './_services/date.service';
import {GlobalService} from './_services/global.service';
import {NavigationEnd, Router} from '@angular/router';

declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
  private roles: string[] = [];
  today = new Date();
  expenseForm!: FormGroup;
  products: string[] = ['Gazoile', 'Elève', 'Moniteur', 'Autre'];
  paymentMethods: string[] = ['ESPECE', 'CB', 'VIREMENT', 'CHEQUE'];
  isLoggedIn = false;
  showAdminBoard = false;
  showMonitorBoard = false;
  showStudentBoard = false;
  isSuperAdmin = false;
  isReadOnly = false;
  username?: string;
  navMobile = false;

  resizeObservable$?: Observable<Event>;
  resizeSubscription$?: Subscription;

  constructor(private fb: FormBuilder, private tokenStorageService: TokenStorageService, private purchaseService: PurchaseService,
              private dateService: DateService, private globalService: GlobalService, private router: Router) {
    this.checkWindowSizeChange();
    this.expenseForm = this.fb.group({
      date: [new Date().toISOString().split('T')[0]],
      cost: [''],
      product: [''],
      paymentMethod: [''],
      reason: [''],
      description: ['']
    });
  }


  ngOnInit(): void {
    this.refreshAuthState();

    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$?.subscribe( evt => {
      this.checkWindowSizeChange();
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.refreshAuthState();
      });

    // Mobile : un clic sur un lien de page (pas sur l'ouverture d'un sous-menu) referme le menu
    $(document).on('click', '#navbarNavDropdown a.nav-link:not(.dropdown-toggle), #navbarNavDropdown a.dropdown-item',
      () => this.closeMobileMenu());
  }

  /** Referme le menu déroulant mobile s'il est ouvert (sans effet sur ordinateur). */
  closeMobileMenu() {
    $('#navbarNavDropdown.show').collapse('hide');
  }

  logout(): void {
    this.tokenStorageService.signOut();
    window.location.reload();
  }

  myFunction() {
  }

  checkWindowSizeChange() {
    if(screen.width < 577) {
      this.navMobile = true;
    } else {
      this.navMobile = false;
    }
  }

  shouldShowMainNavbar(): boolean {
    return !this.isPublicHomeRoute();
  }

  private isPublicHomeRoute(): boolean {
    const routerPath = this.normalizePath(this.router.url);
    const browserPath = this.normalizePath(window.location.pathname);

    return this.isPublicRoute(routerPath) || this.isPublicRoute(browserPath);
  }

  private isPublicRoute(path: string): boolean {
    return path === '/' || path === '/home' || path.startsWith('/home/') || path === '/login' || path.startsWith('/login/');
  }

  private normalizePath(path: string): string {
    const withoutQuery = path.split('?')[0].split('#')[0];
    const normalized = withoutQuery.length > 1 ? withoutQuery.replace(/\/+$/, '') : withoutQuery;

    return normalized || '/';
  }

  private refreshAuthState(): void {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    this.roles = [];
    this.showAdminBoard = false;
    this.showMonitorBoard = false;
    this.showStudentBoard = false;
    this.isSuperAdmin = false;
    this.isReadOnly = false;
    this.username = undefined;

    if (!this.isLoggedIn) {
      return;
    }

    const user = this.tokenStorageService.getUser();
    this.roles = user.roles ?? [];
    this.showAdminBoard = this.roles.includes('ROLE_ADMIN') || this.roles.includes('ROLE_READER');
    this.showMonitorBoard = this.roles.includes('ROLE_MONITOR');
    this.showStudentBoard = this.roles.includes('ROLE_USER');
    this.isSuperAdmin = this.roles.includes('ROLE_SUPER_ADMIN');
    this.isReadOnly = this.roles.includes('ROLE_READER') && !this.roles.includes('ROLE_ADMIN') && !this.isSuperAdmin;
    this.username = user.username;
  }

  onSubmit() {
    const formData = this.expenseForm?.value;
    const purchase = new Purchase(
      formData.id,
      new Date(formData.date),
      formData.cost,
      formData.paymentMethod,
      formData.reason,
      formData.description
    );
    this.purchaseService.addPurchase(purchase).subscribe(
      response => {
        // Close the modal
        $('#expenseModal').modal('hide');
        this.globalService.announceExpenseAdded();
      },
      error => {
        console.error('Error submitting form', error);
      }
    );
  }

}
